import React from 'react';
import SingleDatePicker from '../../../components/SingleDatePicker';
import { todayKST } from '../../../utils/date';
import { inputStyle, helperTextStyle } from './styles';
import { normalizeDepartmentValue, onlyDigits } from './utils';

function isChanged(kind, editing, form) {
  if (!editing) return false;
  if (kind === 'department') {
    return normalizeDepartmentValue(form.department) !== normalizeDepartmentValue(editing.department);
  }
  if (kind === 'bank') {
    return String(form.bank_name || '').trim() !== String(editing.bank_name || '').trim()
      || onlyDigits(form.bank_account || '', 30) !== onlyDigits(editing.bank_account || '', 30);
  }
  return false;
}

export default function UserEffectiveHistoryFields({ kind, editing, form, setForm }) {
  if (!isChanged(kind, editing, form)) return null;

  const prefix = kind === 'department' ? 'department' : 'bank';
  const title = kind === 'department' ? '부서 적용 시작일' : '계좌 적용 시작일';
  const helper = kind === 'department'
    ? '달력에서 날짜를 누르면 그 날짜부터 이 부서가 적용됩니다. 과거 날짜를 고르면 해당 기간의 급여/명세서 기준도 바뀔 수 있습니다.'
    : '달력에서 날짜를 누르면 그 날짜부터 이 계좌가 적용됩니다. 급여이체 엑셀은 급여지급일 기준의 계좌를 사용합니다.';
  const effectiveKey = `${prefix}_effective_from`;
  const reasonKey = `${prefix}_change_reason`;
  const effectiveDate = form[effectiveKey] || todayKST();

  function updateField(key, value) {
    setForm({ ...form, [key]: value });
  }

  return (
    <div style={panelStyle}>
      <div style={titleStyle}>{title}</div>
      <div style={dateBadgeStyle}>적용 시작일 {effectiveDate}</div>
      <SingleDatePicker
        value={effectiveDate}
        onChange={(ymd) => updateField(effectiveKey, ymd)}
      />
      <textarea
        style={{ ...inputStyle, minHeight: 50, resize: 'vertical' }}
        placeholder="변경 사유 또는 메모"
        value={form[reasonKey] || ''}
        onChange={(e) => updateField(reasonKey, e.target.value)}
      />
      <p style={helperTextStyle}>{helper}</p>
    </div>
  );
}

const panelStyle = {
  gridColumn: '1 / -1',
  display: 'grid',
  gap: 10,
  border: '1px solid var(--border)',
  borderRadius: 8,
  padding: 12,
  background: 'var(--bg-subtle)',
};

const titleStyle = {
  fontWeight: 800,
  color: 'var(--text)',
  fontSize: 13,
};

const dateBadgeStyle = {
  border: '1px solid var(--border)',
  borderRadius: 8,
  padding: '8px 10px',
  background: 'var(--bg-card)',
  color: 'var(--text)',
  fontSize: 12,
  fontWeight: 800,
};
